Flup.service('ajaxForm', function (flup, config) {
	$.fn.serializeObject = function () {
		'use strict'
		var a = {},
			b = function (b, c) {
				var d = a[c.name]
				'undefined' != typeof d && d !== null
					? $.isArray(d)
						? d.push(c.value)
						: (a[c.name] = [d, c.value])
					: (a[c.name] = c.value)
			}
		return $.each(this.serializeArray(), b), a
	}
	var svc = this
	var __namedForms = {}
	var __namedConfigs = {}

	svc.create = function ($form, userOpt) {
		return new AjaxForm($form, userOpt)
	}

	svc.configForm = function (name, userOptFunc) {
		__namedConfigs[name] = userOptFunc
	}

	function AjaxForm($form, userOpt) {
		if ($form.data('ajaxForm')) return

		var self = this,
			_$form = $form,
			_userOpt = userOpt || {},
			_name = _userOpt.name || $form.data('name'),
			_$modal = $form.closest('[data-modal]').eq(0),
			_$inputs = $form.find('[name]'),
			_$fileInputs = $form.find(':file')

		if (_name) {
			__namedForms[_name] = self
		}

		var _$submit = $form.find("[type='submit'],[data-submit]")
		if (!_$submit.length && _name) {
			_$submit = $("[data-submit='" + _name + "']")
		}

		self.parseFormData = function () {
			var obj = _$form.serializeObject()
			var out = {}
			for (var x in obj) {
				if (x.indexOf('.') > 0) {
					var sp = x.split('.')
					var o = out
					for (var i = 0; i < sp.length - 1; i++) {
						if (!o[sp[i]]) o[sp[i]] = {}
						o = o[sp[i]]
					}
					o[sp[i]] = obj[x]
				} else {
					out[x] = obj[x]
				}
			}
			return out
		}

		self.addInputValidation = function (name, msg) {
			return flup('input-validation').addError(_$form, name, msg)
		}

		self.clearValidation = function () {
			flup('input-validation').clear(_$form)
		}

		self.clear = function () {
			self.clearValidation()
			_$inputs.val('')
		}

		self.$getForm = function () {
			return _$form
		}
		self.$getInputs = function () {
			return _$inputs
		}
		self.$getSubmit = function () {
			return _$submit
		}

		_$form.submit(function (e) {
			e.preventDefault()
			var configDefaults = config.defaults ? config.defaults(self) : {}
			var userOpt = $.extend({}, configDefaults, _userOpt)
			if (userOpt.name && __namedConfigs[userOpt.name]) {
				$.extend(userOpt, __namedConfigs[userOpt.name](self) || {})
			}

			var opt = {}
			opt.url = _$form.attr('action')
			opt.before = function (opt) {
				self.clearValidation()
				userOpt.before && userOpt.before(opt)
			}
			opt.done = function (opt, res) {
				if (res.validations) {
					var $withErrorElms = []

					for (var x in res.validations) {
						var $errElm = self.addInputValidation(x, res.validations[x])
						if ($errElm) $withErrorElms.push($errElm)
					}

					if (!$withErrorElms.length) return
					flup('focus').focusTopElm($withErrorElms, true)
				}
				userOpt.done && userOpt.done(opt, res)
			}
			opt.fail = function (opt, res) {
				userOpt.fail && userOpt.fail(opt, res)
			}
			opt.always = function (opt, res) {
				_$modal.length && _$modal.modal('resize')
				userOpt.always && userOpt.always(opt, res)
			}

			opt.confirm = _$form.data('confirm') || _$submit.data('confirm') || userOpt.confirm
			opt.loadingFull = _$form.is('[data-loading-full]') || userOpt.loadingFull
			opt.loadingAlert = _$form.is('[data-loading-alert]') || userOpt.loadingAlert
			opt.loadingMsg = _$form.data('loading') || _$form.data('loading-alert') || userOpt.loadingMsg
			opt.$loadingElm = userOpt.$loadingElm || _$submit

			opt.data = self.parseFormData()
			userOpt.editData && userOpt.editData(opt.data)
			opt.files = {}
			_$fileInputs.each(function () {
				var name = $(this).attr('name')
				if ($(this).is('[multiple]')) {
					opt.files[name] = []
					for (var i = 0; i < this.files.length; i++) {
						opt.files[name].push(this.files[i])
					}
				} else {
					opt.files[name] = this.files[0]
				}
			})

			flup('server').request(opt)
		})

		_$form.attr('novalidate', 'true')
		_$form.data('ajaxForm', true)
	}
})

Flup.link('ajax-form', function (flup, $elm, value) {
	flup('ajaxForm').create($elm, { name: value })
})
